export default __webpack_public_path__ + "static/not-found-bg-desktop-new-1e12dcfbd91effc289e8d3f6a9f29739.jpg";